package one.devsbox.www.ui.locations

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.MeProvider
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.viewModel

class ListingLocationCtx private constructor(
    val vm: ListingLocationVM,
    val nav: Navigation,
    val me: MeProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color
) {
    companion object {
        @Composable
        fun get(): ListingLocationCtx {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(ListingLocationVM::class)
            val me = LocalMeProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primary
            val colorSecondary = MaterialTheme.colorScheme.secondary
            return remember {
                ListingLocationCtx(vm, nav, me, colorPrimary, colorSecondary).apply {
                    vm.setup(this)
                }
            }
        }
    }

    val action get() = vm.action
}
